import { NSARouterMakerResult, NSAVerificationPage } from "namirasoft-account-react";
import { SMSSenderProps } from "../SMSSenderProps";
import { SMSSenderLayout } from "../SMSSenderLayout";
import { useParams } from "react-router-dom";
import { NSBoxPhone } from "namirasoft-site-react";
import { useRef } from "react";
import { SMSSenderRoutes } from "../SMSSenderRoutes";

interface VerifySMSPageProps extends NSARouterMakerResult, SMSSenderProps { }

export default function VerifySMSPage(props: VerifySMSPageProps)
{
	let NSBoxPhone_Phone = useRef<NSBoxPhone>(null);

	let { provider_id } = useParams();

	return (
		<SMSSenderLayout
			{...props}
			action={{
				title: "Verification",
				description: "Enter the verification code sent to your phone number to confirm your request and activate the service.",
				menus: {}
			}}
		>
			<NSAVerificationPage
				{...props}
				contact_type={"SMS"}
				contact_value_name={"Phone Number"}
				getContactValue={(checkErrors: boolean) =>
				{
					return NSBoxPhone_Phone.current?.getValue(checkErrors) ?? "";
				}}
				onRequest={async phone =>
				{
					if (provider_id)
						await props.servers.sms_sender.provider.Request(provider_id, { phone });
				}}
				onVerify={async code =>
				{
					if (provider_id)
						await props.servers.sms_sender.provider.Verify(provider_id, { code });
				}}
				onFinished={() =>
				{
					if (provider_id)
						props.url.redirect(SMSSenderRoutes.ProviderView(provider_id), {});
				}}
			>
				<NSBoxPhone
					ref={NSBoxPhone_Phone}
					title="Phone"
					required
				/>
			</NSAVerificationPage>
		</SMSSenderLayout>
	);
}